import parse from "html-react-parser";
import {NEXT_PUBLIC_BASE_URL} from "../../constants/copyright";
import {normalizeOgType, resolveShareImage} from "../../constants/seo";

export function createMetaData() {
  const parseArgs = [...arguments];
  const [
    title = "Медиа Столото",
    description = "",
    image,
    ogTitle,
    ogDescription,
    url = NEXT_PUBLIC_BASE_URL,
    type
  ] = parseArgs?.map((el) => el && parse(el));

  return {
    title,
    description,
    og: {
      type: normalizeOgType(type),
      url,
      image: resolveShareImage(image),
      title: ogTitle ?? title,
      description: ogDescription ?? description,
    }
  };
}
